import { useCallback, useEffect } from "react";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import useRouterPrompt from "./RouterPrompt";

const defaultMessage =
  "Det er ulagrede endringer på siden, er du sikker på at du vil navigere bort?";

const usePrompt = (
  when = false,
  message = defaultMessage,
  beforeUnload = true,
  navigate = true,
) => {
  const callback = useCallback(
    (event: BeforeUnloadEvent): BeforeUnloadEvent | boolean => {
      // eslint-disable-next-line no-param-reassign
      event.returnValue = message;
      return event.returnValue;
    },
    [message],
  );

  useEffect(() => {
    if (when && beforeUnload) window.addEventListener("beforeunload", callback);

    return () => {
      if (when && beforeUnload)
        window.removeEventListener("beforeunload", callback);
    };
  }, [when, beforeUnload, callback]);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return useRouterPrompt({ when: when && navigate, message });
};

export default usePrompt;
